import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import {ResponceStatusService} from "../../sub";
import authService from "../../services/authService";
import {useNavigate} from "react-router-dom";
import { Subscription } from 'rxjs';

const ResponseHandle = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const handleLogout = (redirectPath: string) => {
        dispatch(authService.logout());
        navigate(redirectPath, { replace: true });
    };
    let subscription:Subscription | undefined = undefined
        useEffect(() => {
            subscription = ResponceStatusService.getSub().subscribe((value: any) => {
            if (value?.type === "FLOW" && value?.status === 401) {
                // SSO is the only login method: any 401 clears auth and hands off
                // to the external auth portal ("/" → ExternalRedirect).
                localStorage.removeItem("useRefresh")
                handleLogout("/");
            }
        });
        return () => {
            subscription?.unsubscribe();
        };
    }, []);

    return (
        <div>

        </div>
    );
};

export default ResponseHandle;

